module.exports = __webpack_public_path__ + "static/ALLEGATO36-46c589b71ee197638e1d1be0e308d72c.pdf";